import WebLayout from "../../components/WebLayout";
import Landing from "../../components/landing/Landing";
import ContactForm from "./contactForm/ContactForm";
import Locations from "./locations/Locations";
const Contact = () => {
  return (
    <WebLayout>
      <Landing
        title="Contact us"
        from="Home"
        page="Contact us"
      />
      <ContactForm />
      <Locations />
    </WebLayout>
  );
};

export default Contact;
